import styled from 'styled-components';
import { Layout } from 'antd';
import { Button as StyledButton } from '../../../styles/buttons'

export const Container = styled(Layout)`
  padding: 0.5rem 1rem;
  gap: 1rem;
  position: relative;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;

  @media (max-width: 768px) {
    display: none;
  }  
  .ant-table th,
  .ant-table td {
    min-width: 150px;
    white-space: nowrap;
    
  }
`;

export const ResponsiveTable = styled.div`
`;

export const ResponsiveRow = styled.div`
  display: flex;
  margin: 0 12px 12px 0;
  justify-content: space-between;
  padding:5px;

  text-align: center;
  align-items: center;
  align-content: space-between;

  border-radius: 8px;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const ResponsiveColumn = styled.div`
  text-align: center;
  word-wrap: break-word;
  font-size: 12px;

  padding-top: 2px;
  padding-right: 2px;
`;

export const Button = styled(StyledButton)`
  width: unset;
  margin-top: 0;
  align-self: flex-end;
  border-radius: 20px;
`;

export const ZeroWrapper = styled(Layout)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
`;


export const StatusBadge = styled.span<{ $status: number }>`
  padding: 4px 16px;
  border-radius: 12px;
  font-weight: 600;
  display: inline-block;

  color: ${({ $status }) =>
    $status === 1 ? "white" :
    $status === 0 ? "#8a6d3b" :
    $status === 2 ? "white" :
    $status === 3 ? "white" :
    $status === 4 ? "white" :
    $status === -1 ? "white" :
    $status === -2 ? "white" :
    "black"};

  background: ${({ $status }) =>
    $status === 0 ? "#ffe7a3" :        
    $status === 1 ? "#4caf50" :       
    $status === 2 ? "#d35400" :      
    $status === 3 ? "#e53935" :        
    $status === 4 ? "#9e9e9e" :      
    $status === -1 ? "#795548" :      
    $status === -2 ? "#2196f3" :     
    "#ddd"};
`;